import { SpacingMap, DefaultSpacingName } from './types';

export const defaults: SpacingMap<DefaultSpacingName, string> = {
  0: '0',
  1: '0.25rem',
  2: '0.5rem',
  3: '1rem',
  4: '2rem',
  5: '4rem',
  6: '8rem'
};
